import { getErrorMessage } from '@/utils/helpers'

import axios from './instance'

/**
 * Gets all FAQ entries (RSCX-353). FAQs are a short, RescueX-curated list, so
 * fetch them unpaginated (a valueless `limit` disables pagination server-side).
 * Pass `includeHidden` (admins only) to also get unpublished drafts.
 */
export const getFaqs = async ({ includeHidden = false } = {}) => {
  try {
    return await axios.get(`/faqs/?limit${includeHidden ? '&include_hidden=true' : ''}`)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}

/**
 * Adds a new FAQ entry.
 * @param {object} payload
 */
export const addFaq = async (payload) => {
  try {
    return await axios.post('/faqs/', payload)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}

/**
 * Updates an FAQ entry.
 * @param {object} payload - Must include `id`.
 */
export const updateFaq = async (payload) => {
  try {
    return await axios.patch(`/faqs/${payload.id}/`, payload)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}

/**
 * Deletes an FAQ entry.
 * @param {string} id
 */
export const deleteFaq = async (id) => {
  try {
    return await axios.delete(`/faqs/${id}/`)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}

/**
 * Persists a new FAQ display order. Takes every FAQ id in display order.
 * @param {string[]} ids
 */
export const reorderFaqs = async (ids) => {
  try {
    return await axios.post('/faqs/reorder/', { ids })
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}
